// Default Terms & Conditions body printed at the bottom of every sales
// invoice PDF when no operator-supplied override exists in `app_settings`.
// Kept here so the Settings page (where the user edits the value) and the
// print renderer (where it is finally substituted and shown) share one
// canonical string. Mirrors the structure used by the quotation T&C.
export const DEFAULT_SALES_INVOICE_TERMS = [
  "1. Payment is due within 30 days of the invoice date unless otherwise agreed in writing.",
  "2. Amounts are quoted in Ghana Cedis (GH\u20B5) and inclusive of applicable taxes as itemised above.",
  "3. Cheques should be made payable to {company.name}; please quote the invoice number on all remittances.",
  "4. Overdue balances accrue interest at 1.5% per month (compounded monthly) until settled in full.",
  "5. Goods sold remain the property of {company.name} until full payment is received.",
  "6. Any dispute regarding this invoice must be raised in writing within 7 days of receipt.",
].join("\n");

// Resolves the {company.name} token (and any future tokens) in a stored T&C
// blob right before it lands on the PDF. We do the substitution at render
// time — not on save — so renaming the company retroactively flows through
// every existing invoice without having to rewrite the stored text.
export function renderSalesInvoiceTerms(
  raw: string | null | undefined,
  companyName: string | null | undefined,
): string {
  const body = (raw ?? "").trim().length
    ? String(raw)
    : DEFAULT_SALES_INVOICE_TERMS;
  const safeName = (companyName ?? "").trim() || "BillForge";
  return body.replace(/\{company\.name\}/g, safeName);
}
